import LoadingSpinner from '@carvana/loading-spinner';
import Tabs from '@carvana/showroom-tabs';
import { useContext } from 'react';
import UserVehicleContext from '~/context/vdp/UserVehicleContext';
import { Card } from './Card.styles';
import CoApplicant from './CoApplicant';
import PayMonthlyCard from './PayMonthlyCard';
import PayOnceCard from './PayOnceCard';
import useCanFinance from '../../hooks/selectors/useCanFinance';
import useGetCoApplicantLoading from '../../hooks/selectors/useGetCoApplicantLoading';
import useGetCoApplicantStateEligible from '../../hooks/selectors/useGetCoApplicantStateEligible';
import { SOFTPULL_CARD } from '../constants';

export default function WithSoftPull() {
  const canFinance = useCanFinance();
  const { vdpPricingInfo } = useContext(UserVehicleContext);
  const isCoApplicantStateEligible = useGetCoApplicantStateEligible();
  const isCosignerLoading = useGetCoApplicantLoading();

  const isLoading = vdpPricingInfo.isLoading || isCosignerLoading;

  const { TabBar, Tab, Panel } = Tabs;
  const tabs = [
    {
      group: 'pay-monthly-tab',
      label: 'Pay Monthly',
      content: () => (
        <Card id={SOFTPULL_CARD} isLoading={isLoading}>
          {isLoading && <LoadingSpinner className="absolute h-full" />}
          <PayMonthlyCard />
        </Card>
      )
    },
    {
      group: 'pay-with-cash-tab',
      label: 'Pay with Cash',
      content: () => (
        <Card id={SOFTPULL_CARD} isLoading={isLoading}>
          {isLoading && <LoadingSpinner className="absolute h-full" />}
          <PayOnceCard />
        </Card>
      )
    }
  ];

  return (
    <div
      data-qa="spt-with-softpull"
      className="grid w-full max-w-full auto-cols-fr gap-24 m:max-w-[680px]"
    >
      {canFinance ? (
        <Tabs
          startingTab={canFinance ? 'pay-monthly-tab' : 'pay-with-cash-tab'}
          className="w-full max-w-[680px]"
        >
          <TabBar className="mx-auto mb-40 max-w-[448px]">
            {tabs.map(tab => (
              <Tab
                className="w-full tl-header-xs"
                tabGroup={tab.group}
                key={tab.group}
              >
                <p>{tab.label}</p>
              </Tab>
            ))}
          </TabBar>

          {tabs.map(tab => (
            <Panel
              className="!rounded-md !p-0 !shadow-none"
              tabGroup={tab.group}
              key={tab.group}
            >
              {tab.content()}
            </Panel>
          ))}
        </Tabs>
      ) : (
        <Card id={SOFTPULL_CARD} isLoading={isLoading} className="mt-32">
          {isLoading && <LoadingSpinner className="absolute h-full" />}
          <PayOnceCard />
        </Card>
      )}

      {isCoApplicantStateEligible && canFinance && <CoApplicant />}
    </div>
  );
}
